<mat-drawer-container class="one-container" [ngClass]="{'sliding': isInDetail == true}">
  <div class="pinner-bkg" *ngIf="isLoading">
    <div class="pinner">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <mat-drawer #drawer class="one-sidenav" mode="side" opened>
    <div class="nav fixed">
      <button mat-raised-button color="primary" (click)="openRequestCreateForm()" *ngIf="isInRequest == true">
        <mat-icon aria-hidden="false" aria-label="Add icon">add</mat-icon>
        {{text.CREATE_NEW_REQUEST_TEXT| uppercase }}
      </button>
      <div *ngIf="isGroupRequests" class="home" (click)="navToRequest()">
        <div class="icon">
          <mat-icon class="back" aria-label="Arrow left icon">keyboard_arrow_left</mat-icon>
        </div>
        <div class="label">Tất cả đề xuất</div>
      </div>
      <button *ngIf="isInGroup == true"
        mat-button
        color="warn"
        style="text-align: left;"
        routerLink="/requests">
        <mat-icon aria-hidden="false" aria-label="Home icon">keyboard_arrow_left</mat-icon>
        {{text.HOME | uppercase }}
      </button>
    </div>
    <div class="nav scrollable">
      <mat-list *ngIf="isInRequest == true" class="one-list">
        <mat-list-item class="one-list-item">
          <mat-checkbox [checked]="toMe" (change)="updateToMe($event.checked)">{{text.SEND_TO_ME}}</mat-checkbox>
        </mat-list-item>
        <mat-list-item class="one-list-item">
          <mat-checkbox [checked]="fromMe" (change)="updateFromMe($event.checked)">{{text.MY_REQUESTS}}</mat-checkbox>
        </mat-list-item>
        <mat-list-item class="one-list-item">
          <mat-checkbox [checked]="followed" (change)="updateFollowed($event.checked)">{{text.MY_FOLLOWING}}</mat-checkbox>
        </mat-list-item>
      </mat-list>
      <mat-list *ngIf="isInGroup == true" class="group one-list full">
        <mat-list-item class="one-list-item">
          <div class="li" routerLink="/groups" [ngClass]="{'active': isOnPage('/groups')}">
            <div class="icon">
              <mat-icon class="i" aria-hidden="false" aria-label="List all icon">list_alt</mat-icon>
            </div>
            Tất cả nhóm đề xuất
          </div>
        </mat-list-item>
        <mat-list-item class="one-list-item" *ngIf="false">
          <div class="li" routerLink="/systemRequest" routerLinkActive="active">
            <div class="icon">
              <mat-icon class="i" aria-hidden="false" aria-label="System groups icon">widgets</mat-icon>
            </div>
            Tất cả đề xuất hệ thống
          </div>
        </mat-list-item>
        <mat-list-item class="hidden one-list-item">
          <div class="li">
            <div class="icon">
              <mat-icon class="i" aria-hidden="false" aria-label="Change history icon">change_history</mat-icon>
            </div>
            Lịch sử chỉnh sửa nhóm
          </div>
        </mat-list-item>
        <mat-list-item class="hidden one-list-item">
          <div class="li">
            <div class="icon">
              <mat-icon class="i" aria-hidden="false" aria-label="Available groups icon">bookmark_border</mat-icon>
            </div>
            Mẫu đề xuất có sẵn
          </div>
        </mat-list-item>
        <mat-list-item class="one-list-item">
          <div class="li" (click)="openGroupCreateForm()">
            <div class="icon">
              <mat-icon class="i" aria-hidden="false" aria-label="Add icon">add_circle_outline</mat-icon>
            </div>
            Thêm nhóm mới
          </div>
        </mat-list-item>
      </mat-list>
      <mat-accordion class="one-accordion" multi>
        <mat-expansion-panel expanded="true" class="one-expansion" *ngFor="let groupped of grouppedGroups">
          <mat-expansion-panel-header class="one-expansion-header">
            <mat-panel-title>
              {{groupped.category| uppercase }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-list class="one-list">
            <mat-list-item class="one-list-item" [ngClass]="{'is-route': isInRouting(group.id)}" *ngFor="let group of groupped.groups" (click)="navToGroup(group)">
              <mat-icon class="hidden icon" aria-hidden="false" aria-label="Star icon">star_border</mat-icon>
              <div class="text">{{group.name}}</div>
            </mat-list-item>
          </mat-list>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </mat-drawer>
  <mat-drawer-content class="request-content">
    <router-outlet></router-outlet>
  </mat-drawer-content>
</mat-drawer-container>
